module.exports = __webpack_public_path__ + "static/media/IMG_3498_sm.a014599e.jpg";